import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MediaQuery from "react-responsive";
import { ImMail3 } from "react-icons/im";
import { IoCall } from "react-icons/io5";
import { IoCallOutline } from "react-icons/io5";
import { AiOutlineMail } from "react-icons/ai";
import { SlLocationPin } from "react-icons/sl";
import { MdPermIdentity } from "react-icons/md";
import { FiShoppingCart } from "react-icons/fi";
import { BiMenu } from "react-icons/bi";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import { IoIosArrowBack } from "react-icons/io";
import { BiHomeAlt } from "react-icons/bi";
import { MdMiscellaneousServices } from "react-icons/md";
import { IoInformationCircleOutline } from "react-icons/io5";
import { IoDocumentTextOutline } from "react-icons/io5";
import { TfiGallery } from "react-icons/tfi";
import { SlSocialYoutube } from "react-icons/sl";
import { MdOutlinePrivacyTip } from "react-icons/md";
import shoppingcart from "./shoppingcart.png";
import { CardTravel } from "@mui/icons-material";
import { Button } from "@mui/material";
import { auth } from "./firebase";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { MdLogout } from "react-icons/md";

const scrollToServices = () => {
  window.scrollTo({
    top: 380,
    behavior: "smooth",
    /* you can also use 'auto' behaviour
       in place of 'smooth' */
  });
};
const scrollToAboutUs = () => {
  window.scrollTo({
    top: 2800,
    behavior: "smooth",
    /* you can also use 'auto' behaviour
       in place of 'smooth' */
  });
};
const scrollToWhyUs = () => {
  window.scrollTo({
    top: 3400,
    behavior: "smooth",
    /* you can also use 'auto' behaviour
       in place of 'smooth' */
  });
};
const scrollToGallery = () => {
  window.scrollTo({
    top: 4250,
    behavior: "smooth",
    /* you can also use 'auto' behaviour
       in place of 'smooth' */
  });
};
const scrollToVideos = () => {
  window.scrollTo({
    top: 4800,
    behavior: "smooth",
    /* you can also use 'auto' behaviour
       in place of 'smooth' */
  });
};
const scrollToTestimonials = () => {
  window.scrollTo({
    top: 5550,
    behavior: "smooth",
    /* you can also use 'auto' behaviour
       in place of 'smooth' */
  });
};
const scrollToContactUs = () => {
  window.scrollTo({
    top: 6070,
    behavior: "smooth",
    /* you can also use 'auto' behaviour
       in place of 'smooth' */
  });
};
const scrollToPrivacyPolicy = () => {
  window.scrollTo({
    top: 100,
    behavior: "smooth",
    /* you can also use 'auto' behaviour
       in place of 'smooth' */
  });
};

const BasicHeader = ({ language }) => {
  const [user, setUser] = useState(null);
  const [hasReloaded, setHasReloaded] = useState(false); // Flag to track reload
  const [displayName, setDisplayName] = useState("");

  const auth = getAuth();
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        setDisplayName(user.displayName);
        if (!hasReloaded) {
          setHasReloaded(true);
          console.log("window_reloaded");
        }
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe(); // Cleanup the listener when the component unmounts
  }, [1000]); // Empty dependency array ensures the effect runs only once

  useEffect(() => {
    const storedReloadFlag = localStorage.getItem("hasReloaded");
    if (storedReloadFlag) {
      setHasReloaded(true);
      localStorage.removeItem("hasReloaded");
    }

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        setDisplayName(user.displayName);
        if (!hasReloaded) {
          setHasReloaded(true);
          localStorage.setItem("hasReloaded", "true"); // Set the flag in localStorage
          console.log("window_reloaded");
        }
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe(); // Cleanup the listener when the component unmounts
  }, []); // Empty dependency array ensures the effect runs only once

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        setUser(null);
        window.location.reload();
        console.log("window_reloaded");
      })
      .catch((error) => {
        // An error happened.
        console.log(error);
      });
  };

  const [state, setState] = React.useState({
    left: false,
  });

  const handleOp = () => {
    setShowPage(false);
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const [showPage, setShowPage] = useState(false);

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "left" ? 275 : 300 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      {/* <List>
        {["Welcome"].map((text, index) => (
          <ListItem
            key={text}
            disablePadding
            className="hover:bg-gray-200 font-bold"
          >
            <ListItemButton onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} className="font-bold" />
            </ListItemButton>
          </ListItem>
        ))}
        {["Log In/Sign Up"].map((text, index) => (
          <ListItem key={text} disablePadding className="hover:bg-gray-200">
            <ListItemButton onClick={() => {
              {<LoginForm />};
              console.log("loginform");
              toggleDrawer(anchor, false);
            }}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List> */}
      <Divider />
      {/* <List className="flex flex-row"> */}
      {/* {["Language"].map((text, index) => (
          <ListItem key={text} disablePadding className="hover:bg-gray-200">
            <ListItemButton onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))} */}
      {/* <Box sx={{ minWidth: 120 }} className="pr-4">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Language</InputLabel>

            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={age}
              label="Language"
              onChange={handleChange}
            >
              <MenuItem value="English">English</MenuItem>
              <MenuItem value="हिंदी">हिंदी</MenuItem>
              <MenuItem value="मराठी">मराठी</MenuItem>
              <MenuItem value="বাংলা">বাংলা</MenuItem>
              <MenuItem value="தமிழ்">தமிழ்</MenuItem>
              <MenuItem value="ગુજરાતી">ગુજરાતી</MenuItem>
              <MenuItem value="ಕನ್ನಡ">ಕನ್ನಡ</MenuItem>
              <MenuItem value="മലയാളം">മലയാളം</MenuItem>
              <MenuItem value="తెలుగు">తెలుగు</MenuItem>
              <MenuItem value="ਪੰਜਾਬੀ">ਪੰਜਾਬੀ</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </List> */}
      <Divider />
      <List>
        {["Home"].map((text, index) => (
          <ListItem key={text} disablePadding className="hover:bg-gray-200">
            <ListItemButton>
              <ListItemIcon>
                <BiHomeAlt />
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {[
          { text: "Services", index: 0 },
          { text: "About Us", index: 1 },
          { text: "Why Us", index: 2 },
          { text: "Gallery", index: 3 },
          { text: "Videos", index: 4 },
          { text: "Testimonials", index: 5 },
          { text: "Contact Us", index: 6 },
          { text: "Privacy Policy", index: 7 },
        ].map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              onClick={() => {
                if (item.index === 0) {
                  scrollToServices();
                } else if (item.index === 1) {
                  scrollToAboutUs();
                } else if (item.index === 2) {
                  scrollToWhyUs();
                } else if (item.index === 3) {
                  scrollToGallery();
                } else if (item.index === 4) {
                  scrollToVideos();
                } else if (item.index === 5) {
                  scrollToTestimonials();
                } else if (item.index === 6) {
                  scrollToContactUs();
                } else if (item.index === 7) {
                  scrollToPrivacyPolicy();
                }
                toggleDrawer(anchor, false);
              }}
            >
              <ListItemIcon key={item.index}>
                {item.index === 0 ? (
                  <MdMiscellaneousServices />
                ) : item.index === 1 ? (
                  <IoInformationCircleOutline />
                ) : item.index === 2 ? (
                  <IoDocumentTextOutline />
                ) : item.index === 3 ? (
                  <TfiGallery />
                ) : item.index === 4 ? (
                  <SlSocialYoutube />
                ) : item.index === 5 ? (
                  <MdPermIdentity />
                ) : item.index === 6 ? (
                  <IoCallOutline />
                ) : item.index === 7 ? (
                  <MdOutlinePrivacyTip />
                ) : null}
              </ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      <div className="mb-2 md:mb-0 md:mt-0">
        <MediaQuery maxWidth={412}>
          {showPage ? (
            <div className="h-screen pt-4 fixed opacity-1 z-10 bg-white w-screen left-0 overflow-auto">
              <div className="flex flex-row justify-between">
                <div className="flex flex-row space-x-2 pl-2">
                  <button onClick={handleOp} >
                    {/* <IoIosArrowBack /> */}
                  </button>
                  <p className="pt-1">
                    {/* <BiMenu /> */}
                  </p>
                </div>
                <p className="font-semibold text-gray-600 text-2xl">My Cart</p>
                <div className="flex flex-row">
                  <p className="text-white">
                    <IoIosArrowBack />
                  </p>
                  <p className="pt-1 text-white">
                    <BiMenu />
                  </p>
                </div>
              </div>
              <div className="h-screen flex flex-col items-center justify-center space-y-4">
                <div className="text-center flex justify-center items-center">
                  <img
                    src={shoppingcart}
                    className="scale-50 absolute top-12"
                  />
                </div>
                <div className="flex justify-center items-center flex-col relative top-20 pb-12 space-y-4">
                  <p className="text-center font-bold text-gray-600 text-xl">
                    Your Cart is Empty
                  </p>
                  <p className="w-[70%] text-center">
                    Looks Like You haven't made Your Choice Yet
                  </p>
                  <button
                    onClick={() => setShowPage(false)}
                    className="rounded-3xl bg-orange-500 px-12 py-2 text-white font-semibold shadow-lg hover:shadow-hidden"
                  >
                    Start Shopping Now
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex justify-between mb-4 mt-2 w-full pr-2">
              <div>
                {["left"].map((anchor) => (
                  <React.Fragment key={anchor}>
                    <Button
                      onClick={toggleDrawer(anchor, true)}
                      className="text-black"
                    >
                      <BiMenu />
                    </Button>
                    <Drawer
                      anchor={anchor}
                      open={state[anchor]}
                      onClose={toggleDrawer(anchor, false)}
                    >
                      {list(anchor)}
                    </Drawer>
                  </React.Fragment>
                ))}
              </div>
              {language === "en" && (
                <p className="font-bold flex justify-center text-center items-center italic text-2xl">
                  Sthapna
                </p>
              )}
              {language === "hi" && (
                <p className="font-bold flex justify-center text-center items-center italic text-2xl">
                  स्थापना
                </p>
              )}
              <div className="flex flex-row gap-4 pt-1 ml-">
                <button onClick={() => setShowPage(true)}>
                  <FiShoppingCart />
                </button>
                <a href="tel:+91-8890073787" className="mt-1">
                  <IoCallOutline />
                </a>
              </div>
            </div>
          )}
        </MediaQuery>
        <MediaQuery minWidth={413}>
          <div className="flex sm:flex-row mt-2 justify-between flex-col">
            <div className="flex flex-row">
              <div className="flex flex-row gap-2 ml-4 sm:ml-16 lg:ml-4">
                <a
                  href="tel:+91-8890073787"
                  className="text-xl mt-2 hover:text-orange-500 tranform ease-in-out duration-300"
                >
                  <IoCall />
                </a>
                <a href="mailto:archimaya83@gmail.com">
                <ImMail3 className="text-xl mt-2 hover:text-orange-500 tranform ease-in-out duration-300" />
                </a>
                <a href="https://www.justdial.com/Jaipur/Sthapana-Behind-Sodala-Thana-Sodala/0141PX141-X141-180125131502-G6Y9_BZDET" 
                className="font-extrabold text-2xl hover:text-orange-500 tranform ease-in-out duration-300">
                  JD
                </a>
              </div>
              <div className="flex flex-col md:flex-row">
                <a
                  className="ml-6 flex flex-row hover:text-orange-500 text-gray-700"
                >
                  <div className="ml-6 flex flex-row hover:text-orange-500 text-gray-700 tranform ease-in-out duration-300">
                    <a href="tel:+91-8890073787">
                    <IoCallOutline className="text-xl mt-2" />
                    </a>
                    <a href="tel:+91-8890073787" className="pl-2 mt-1">+91-8890073787</a>
                  </div>
                  <div className="ml-6 flex flex-row hover:text-orange-500 text-gray-700 tranform ease-in-out duration-300">
                    <a href="mailto:archimaya83@gmail.com"><AiOutlineMail className="text-xl mt-2 " /></a>
                    <a href="mailto:archimaya83@gmail.com" className="pl-2 mt-1">archimaya83@gmail.com</a>
                  </div>
                </a>
              </div>
            </div>
            <div>
              <div className="flex flex-col md:flex-row md:space-x-5 mr-1">
                <div className="flex flex-row hover:text-orange-500">
                  <SlLocationPin className="text-xl mt-1.5 " />
                  {/* <p className="pl-1 mt-1">Sodala</p> */}
                  {language === "en" && (
                    <a
                      href="https://maps.google.com/maps/dir//Sthapna+architects+WQ2G%2B78G+Ramnagar+Main+Rd,+Shiv+Puri+Colony,+Sodala+Jaipur,+Rajasthan+302007/@26.9006775,75.7758423,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x396db59e54a6e2b9:0x9781ff1d59d9fd54"
                      className={`pl-1 ${user? "mt-1" : "mt-1"}`}
                    >
                      Sodala
                    </a>
                  )}
                  {language === "hi" && (
                    <a
                      href="https://maps.google.com/maps/dir//Sthapna+architects+WQ2G%2B78G+Ramnagar+Main+Rd,+Shiv+Puri+Colony,+Sodala+Jaipur,+Rajasthan+302007/@26.9006775,75.7758423,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x396db59e54a6e2b9:0x9781ff1d59d9fd54"
                      className="pl-1 mt-1"
                    >
                      सोडाला
                    </a>
                  )}
                </div>

                {user ? (
                  <div className="flex flex-row rounded-lg bg-gray-800 text-white px-2 py-1 mb-1.5 font-semibold hover:bg-gray-700 transition ease-in-out duration-300">
                    <div className="flex flex-row gap-1 items-center">
                      {user.photoURL && (
                        <img
                          src={user.photoURL}
                          className="w-8 h-8 rounded-full"
                        />
                      )}
                      {language === 'en' && (
                      <p>Welcome, {user.displayName} </p>
                      )}
                      {language === 'hi' && (
                      <p>नमस्ते, {user.displayName} </p>
                      )}
                    </div>
                    {language === 'en' && (
                    <button
                      className="ml-6 pt-1 flex flex-row justify-center transform transition duration-500 ease-in-out hover:text-cyan-400"
                      onClick={() => {
                        handleLogout();
                      }}
                    >
                      <MdLogout className="mt-1 mr-1 scale-125" />
                      Log Out
                    </button>
                    )}
                    {language === 'hi' && (
                    <button
                      className="ml-6 pt-1 flex flex-row justify-center transform transition duration-500 ease-in-out hover:text-cyan-400"
                      onClick={() => {
                        handleLogout();
                      }}
                    >
                      <MdLogout className="mt-1 mr-1 scale-125" />
                      लॉग आउट
                    </button>
                    )}
                  </div>
                ) : (
                  <div className="flex flex-row mr-8 text-gray-700 hover:text-orange-500">
                    <MdPermIdentity className="text-xl mt-2 " />
                    <LoginForm language={language} />
                    {/* <p className="pl-1 mt-1 text-gray-500 hover:text-orange-500">
                  Login
                </p> */}
                    <p className="pl-1 mt-1 text-gray-500 right-4">|</p>
                    <SignupForm language={language} />
                    {/* <p className="pl-1 mt-1 text-gray-500 hover:text-orange-500">
                  Sign Up
                </p> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        </MediaQuery>
      </div>
    </div>
  );
};

export default BasicHeader;
